import { useEffect, useState } from 'react'

interface UseKeyPressesParams {
  filter?: (e: KeyboardEvent) => boolean
  onPress?: (e: KeyboardEvent) => void
}

export function useKeyPresses(
  params?: UseKeyPressesParams | undefined,
): KeyboardEvent | null {
  const [keyPress, setKeyPress] = useState<KeyboardEvent | null>(null)

  useEffect(() => {
    const keyDownHandler = (e: KeyboardEvent) => {
      setKeyPress(e)
      if (params?.filter && !params.filter(e)) {
        return
      }

      params?.onPress?.(e)
    }

    const keyUpHandler = () => {
      setKeyPress(null)
    }

    window.addEventListener('keydown', keyDownHandler)
    window.addEventListener('keyup', keyUpHandler)

    return () => {
      window.removeEventListener('keydown', keyDownHandler)
      window.removeEventListener('keyup', keyUpHandler)
    }
  }, [params?.onPress])

  return keyPress
}
